<div class="p-2 pb-5">
    <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn" [ngClass]="mode==='disable' ? 'btn-primary' : 'btn-outline-primary'" (click)="setMode('disable')">Disable Game</button>
            <button type="button" class="btn" [ngClass]="mode==='images' ? 'btn-primary' : 'btn-outline-primary'" (click)="setMode('images')">Game Images</button>
        </div>
        <button class="btn btn-primary btn-sm" (click)="save()" *ngIf="mode==='disable' && !loading">Save</button>
    </div>

    <!-- DISABLE GAME TAB -->
    <ng-container *ngIf="mode==='disable'">
        <div class="height">
            <div class="d-flex justify-content-center" *ngIf="loading">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <table class="table table-bordered table-sm" *ngIf="!loading">
                <thead>
                    <tr>
                        <td>Disabled</td>
                        <th>No</th>
                        <th>Image</th>
                        <th>Supplier</th>
                        <th>Type</th>
                        <th>Name</th>
                    </tr>
                    <tr>
                        <th colspan="3"></th>
                        <th><input type="text" class="form-control form-control-sm" placeholder="Search Supplier" (input)="searchSupplier($event)" /></th>
                        <th><input type="text" class="form-control form-control-sm" placeholder="Search Type" (input)="searchType($event)" /></th>
                        <th><input type="text" class="form-control form-control-sm" placeholder="Search Name" (input)="searchName($event)" /></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let game of games; let i = index">
                        <td><input type="checkbox" class="form-check-input" [id]="'game_' + i" [name]="'game_' + i" [ngModel]="game.checked" value="1" (change)="gameChecked(game)" /></td>
                        <td>{{i +  1}}</td>
                        <td style="width: 90px;">
                            <div class="d-flex align-items-center gap-2">
                                <img *ngIf="game.image" [src]="game.image" alt="game" width="40" height="40" style="object-fit: contain; border-radius: 4px; background:#f4f4f4;" />
                                <span *ngIf="!game.image" class="text-muted small">No Image</span>
                                <ng-container *ngIf="game.id">
                                    <div *ngIf="game.uploading" class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">...</span></div>
                                    <label *ngIf="!game.uploading" [for]="'img_' + i" class="btn btn-outline-secondary btn-sm mb-0" title="Upload image">&#8593;</label>
                                    <input type="file" accept="image/*" class="d-none" [id]="'img_' + i" (change)="uploadImage($event, game)" />
                                </ng-container>
                            </div>
                        </td>
                        <td><label [for]="'game_' + i">{{game.platform}}</label></td>
                        <td><label [for]="'game_' + i">{{game.category}}</label></td>
                        <td><label [for]="'game_' + i">{{game.name}}</label></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <button class="btn btn-primary btn-sm w-100" (click)="save()" *ngIf="!loading">Save</button>
    </ng-container>

    <!-- GAME IMAGES TAB — full supplier_game catalog (any platform, incl. Playtech) -->
    <ng-container *ngIf="mode==='images'">
        <div class="row g-2 mb-2">
            <div class="col-6 col-md-3">
                <input type="text" class="form-control form-control-sm" placeholder="Platform (e.g. PLAYTECH)" [(ngModel)]="imgFilter.platform" (input)="searchImages()" />
            </div>
            <div class="col-6 col-md-3">
                <input type="text" class="form-control form-control-sm" placeholder="Name" [(ngModel)]="imgFilter.name" (input)="searchImages()" />
            </div>
            <div class="col-6 col-md-3">
                <input type="text" class="form-control form-control-sm" placeholder="Category (slot/live/table)" [(ngModel)]="imgFilter.category" (input)="searchImages()" />
            </div>
            <div class="col-6 col-md-3 d-flex align-items-center">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="missing_only" [(ngModel)]="imgFilter.missing" (change)="loadImages(true)" />
                    <label class="form-check-label small" for="missing_only">Only missing / placeholder image</label>
                </div>
            </div>
        </div>

        <div class="height">
            <div class="d-flex justify-content-center" *ngIf="imgLoading">
                <div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>
            </div>
            <table class="table table-bordered table-sm" *ngIf="!imgLoading">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Image</th>
                        <th>Upload</th>
                        <th>Platform</th>
                        <th>Category</th>
                        <th>Name</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="imgGames.length === 0">
                        <td colspan="6" class="text-center text-muted">No games found</td>
                    </tr>
                    <tr *ngFor="let game of imgGames; let i = index">
                        <td>{{ (imgPage - 1) * imgSize() + i + 1 }}</td>
                        <td style="width: 60px;">
                            <img *ngIf="game.image" [src]="game.image" alt="game" width="40" height="40" style="object-fit: contain; border-radius: 4px; background:#f4f4f4;" />
                            <span *ngIf="!game.image" class="text-muted small">None</span>
                        </td>
                        <td style="width: 70px;">
                            <div *ngIf="game.uploading" class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">...</span></div>
                            <label *ngIf="!game.uploading" [for]="'imgu_' + i" class="btn btn-outline-secondary btn-sm mb-0" title="Upload image">&#8593; Upload</label>
                            <input type="file" accept="image/*" class="d-none" [id]="'imgu_' + i" (change)="uploadImage($event, game)" />
                        </td>
                        <td>{{game.platform}}</td>
                        <td>{{game.category}}</td>
                        <td>{{game.name}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="d-flex justify-content-between align-items-center" *ngIf="!imgLoading">
            <small class="text-muted">{{imgTotal}} game(s) — page {{imgPage}} / {{imgTotalPages || 1}}</small>
            <div class="btn-group btn-group-sm">
                <button class="btn btn-outline-secondary" [disabled]="imgPage<=1" (click)="imgPrev()">Prev</button>
                <button class="btn btn-outline-secondary" [disabled]="imgPage>=imgTotalPages" (click)="imgNext()">Next</button>
            </div>
        </div>
    </ng-container>
</div>
